export default "__VITE_ASSET__35637238__"